import React, { useState, useEffect } from "react";


import { makeStyles } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Switch from "@mui/material/Switch";

import {
  Card,
  CardActions,
  CardContent,
  Divider,
  Button,
  Grid,
  TextField,
  CardHeader,
  Box,
  Typography,
} from "@mui/material";
import {
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { TimePicker } from "@mui/x-date-pickers";

import clsx from "clsx";

import { useSelector, useDispatch } from "react-redux";


import API from "util/API";
import { useHistory } from "react-router-dom";
import {
  showSuccessSnackbar,
  showErrorSnackbar,
} from "store/actions/snackbarMessage";
import { useForm, Controller } from "react-hook-form";
import moment from "moment";
import BookingTables from "./BookingTables";
import { v4 as uuid } from "uuid";

import { noWheelInputProps } from "util/utils";
const useStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
  root: {
    padding: theme.spacing(3),
  },
  details: {
    display: "flex",
  },
  avatar: {
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0,
  },
  locationText: {
    paddingLeft: "15px",
  },
  buttonProperty: {
    position: "absolute",
    top: "50%",
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  progess: {
    position: "absolute",
  },
  uploadButton: {
    marginLeft: "8px",
    margin: theme.spacing(1),
  },
  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },
  submitButton: {
    marginTop: "10px",
  },
}));

function required(displayName) {
  return function validateRequired(value) {
    // console.log("VALIDATING: ", displayName, value);
    return value !== null || `${displayName} is required.`;
  };
}

const defaultValues = {
  guestNum: null,
  startTime: null,
  endTime: null,
};

const BookingSession = (props) => {

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const showError = (msg) => dispatch(showErrorSnackbar(msg));
  const showSuccess = (msg) => dispatch(showSuccessSnackbar(msg));
  const session = useSelector((state) => state.restaurant.selectedBookingSession);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm({
    defaultValues,
  });

  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [tables, setTables] = useState([]);
  const [depositRequired, setDepositRequired] = useState(false);

  const [buttonLoading, setButtonLoading] = useState(false);
  const [disableEndTime, setDisableEndTime] = useState(false);
  const [hideTableNo, setHideTableNo] = useState(false);
  

  const loadTables = async () => {
    try {
      const response = await API.get("/tableInfo");
      const data = await response.data;
      if (data && data.tableInfo && data.tableInfo.areas) {
        //console.log(data);
        const areas = data.tableInfo.areas;
        const allTables = areas.flatMap((floor) => floor.hasTables);
        //console.log(allTables);
        const tableList = allTables.map((table) => {
          return {
            id: uuid(),
            tableNumber: table.tableNumber,
            guestNumber: table.numberOfGuests,
            minNumOfGuests:
              table.minNumOfGuests !== null && table.minNumOfGuests !== undefined
                ? (table.minNumOfGuests === 0 ? table.numberOfGuests : table.minNumOfGuests)
                : table.numberOfGuests,
          };
        });
        //console.log(tableList);
        setTables(tableList);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const setSpecificTime = (time) => {
    if (time && typeof time === 'string' && time.split(':').length === 2) {
      const hourAndMinutes = time.split(':');
      const momentDate = moment().set('hour', hourAndMinutes[0]).set('minute', hourAndMinutes[1]);
      return momentDate.isValid() ? momentDate.toDate() : null;
    }
    return null;
  };

  const updateSessionData = () => {
    reset(session);
    //console.log(moment().startOf(session.startTime));
    const oldStartTime = setSpecificTime(session.startTime);
    if (oldStartTime) {
      setStartTime(oldStartTime);
    }
    const oldEndTime = setSpecificTime(session.endTime);
    if (oldEndTime) {
      setEndTime(oldEndTime);
    }
    setTables(session.tables)
    setDepositRequired(session.depositRequired);

    if (session.disableEndTime !== undefined) {
      setDisableEndTime(session.disableEndTime);
    }
    if (session.hideTableNo !== undefined) {
      setHideTableNo(session.hideTableNo); 
    }
  };

  useEffect(() => {
    if (!session) {
      loadTables();
    } else {
      updateSessionData();
    }
  }, [props, session]);

  const saveSession = async (sessionObj) => {

    try {
      setButtonLoading(true);
      let response;
      if (session) {
        response = await API.put("/bookingSession", { ...sessionObj, sessionId: session.sessionId });
      } else {
        response = await API.post("/bookingSession", sessionObj);
      }

      const data = await response.data;
      if (data) {
        //console.log(data);
        setButtonLoading(false);
        showSuccess('Saved successfully!');
        history.push('/bookingSessions');
      }
    } catch (err) {
      console.log(err);
      setButtonLoading(false);
      showError("Something went wrong! Cannot save the session!");
    }
  };

  const onSubmit = (data) => {
    // Validate times are set and valid
    if (!startTime || !endTime) {
      showError("Please select both start and end times.");
      return;
    }

    if (startTime > endTime) {
      showError("The end time cannot be greater than the start time.");
      return;
    }

    const sessionObj = {
      ...data,
      tables: tables.map((table) => ({ ...table, guestNumber: Number(table.guestNumber), minNumOfGuests: Number(table.minNumOfGuests) })),
      guestNum: Number(data.guestNum)
    };
    // console.log(sessionObj, Number(data.guestNum));
    saveSession(sessionObj);

  };

  const handleStartTime = (date) => {
    // Only set valid dates or null
    if (date && moment(date).isValid()) {
      setStartTime(date);
      setValue("startTime", moment(date).format("HH:mm"));
    } else if (date === null) {
      setStartTime(null);
      setValue("startTime", null);
    }
  };

  const handleEndTime = (date) => {
    // Only set valid dates or null
    if (date && moment(date).isValid()) {
      setEndTime(date);
      setValue("endTime", moment(date).format("HH:mm"));
    } else if (date === null) {
      setEndTime(null);
      setValue("endTime", null);
    }
  };

  useEffect(() => {
    register("startTime", { validate: required("Start time") });
    register("endTime", { validate: required("End time") });
  }, [props]);

  const toggleDepositChecked = () => {
    setDepositRequired((depositRequired) => !depositRequired);
  };

  const toggleEndTime = () => {
    setDisableEndTime((disableEndTime) => !disableEndTime);
  };

  const toggleTableNo = () => {
    setHideTableNo((hideTableNo) => !hideTableNo);
  };

  return (
    <div className={classes.content}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Card className={clsx(classes.root, classes)}>
          <CardHeader title="Booking Session" />
          <Divider />
          <CardContent>
            <Grid container spacing={{ xs: 2, md: 3 }}>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ minHeight: 56, justifyContent: "center", gap: 0.5 }}
                >
                  <Typography variant="body2" gutterBottom>Session Enabled</Typography>
                  <Controller
                    name="sessionEnabled"
                    defaultValue={true}
                    control={control}
                    render={({ field }) => (
                      <Switch
                        onChange={(e) => field.onChange(e.target.checked)}
                        checked={field.value || false}
                      />
                    )}
                  />
                </Box>
              </Grid>

              <Grid item>
                <TextField 
                  {...register("name", { required: "Name is required" })}
                  label="Session Name"
                  variant="outlined"
                  size="small"
                  error={!!errors.name}
                  helperText={errors.name?.message || ""}
                />
              </Grid>

              <Grid item >
                <TextField 
                  {...register("sessionDesription")}
                  label="Session Description"
                  variant="outlined"
            
                />
              </Grid>

              <Grid item >
                <TextField 
                  {...register("guestNum", { 
                    required: "Guest number is required",
                    min: { value: 1, message: "Guest number must be greater than 0" }
                  })}
                  type="number"
                  inputProps={noWheelInputProps}
                  label="Guest Number limit"
                  variant="outlined"
                  error={!!errors.guestNum}
                  helperText={errors.guestNum?.message || ""}
                />
              </Grid>

              <Grid item >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    label="Start Time"
                    name="startTime"
                    value={startTime}
                    onChange={handleStartTime}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        size: "small",
                        error: errors.hasOwnProperty("startTime"),
                        helperText: errors.startTime && errors.startTime.message
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    label="End Time"
                    name="endTime"
                    value={endTime}
                    onChange={handleEndTime}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        fullWidth: true,
                        error: errors.hasOwnProperty("endTime"),
                        helperText: errors.endTime && errors.endTime.message
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ minHeight: 56, justifyContent: "center", gap: 0.5 }}
                >
                  <Typography variant="body2" gutterBottom>Hide End Time</Typography>
                  <Controller
                    name="disableEndTime"
                    defaultValue={false}
                    control={control}
                    render={props =>
                      <Switch
                        onChange={e => {props.onChange(e.target.checked); toggleEndTime();}}
                        checked={props.value}
                      />
                    }
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ minHeight: 56, justifyContent: "center", gap: 0.5 }}
                >
                  <Typography variant="body2" gutterBottom>Hide Table Number</Typography>
                  <Controller
                    name="hideTableNo"
                    defaultValue={false}
                    control={control}
                    render={props =>
                      <Switch
                        onChange={e => {props.onChange(e.target.checked); toggleTableNo();}}
                        checked={props.value}
                      />
                    }
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ minHeight: 56, justifyContent: "center", gap: 0.5 }}
                >
                  <Typography variant="body2" gutterBottom>Need deposit</Typography>
                  <Controller
                    name="depositRequired"
                    defaultValue={false}
                    control={control}
                    render={props =>
                      <Switch
                        onChange={e => { props.onChange(e.target.checked); toggleDepositChecked(); }}
                        checked={props.value}
                      />
                    }
                  />
                </Box>
              </Grid>

              {depositRequired && (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField 
                    {...register("deposit", { 
                      required: depositRequired ? "Deposit is required" : false,
                      min: { value: 1, message: "Deposit must be greater than 0" }
                    })}
                    type="number"
                    inputProps={noWheelInputProps}
                    label="Deposit"
                    variant="outlined"
                    fullWidth
                    error={!!errors.deposit}
                    helperText={errors.deposit?.message || ""}
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <BookingTables updateTables={setTables} tablesList={tables} />
              </Grid>
            </Grid>
          </CardContent>

          <CardActions />
        </Card>

        <Button
          color="primary"
          name="button"
          variant="contained"
          type="submit"
          className={classes.submitButton}
          disabled={buttonLoading}
        >
          Save Session
          {buttonLoading && (
            <CircularProgress size={30} className={classes.progess} />
          )}
        </Button>
      </form>
    </div>
  );
};

export default BookingSession;
